/** Audit-history service (T035/T037, US3). Wraps the getEntityHistory callable. */
import { callable } from './firebase';

/** A Firestore timestamp as serialized over a callable. */
export interface SerializedTimestamp {
  _seconds?: number;
  _nanoseconds?: number;
}

export interface AuditHistoryEntry {
  event_id: string;
  before: Record<string, unknown> | null;
  after: Record<string, unknown>;
  source: string;
  actor: string;
  timestamp: SerializedTimestamp | string;
}

export interface EntityHistory {
  events: AuditHistoryEntry[];
  prior_state: Record<string, unknown> | null;
}

export type HistoryCollection =
  | 'clients'
  | 'billing_identities'
  | 'projects'
  | 'proposals'
  | 'source_links'
  | 'persons';

export const getEntityHistory = callable<
  { collection: HistoryCollection; document_id: string; limit?: number },
  EntityHistory
>('getEntityHistory');

/** Best-effort display of a callable-serialized timestamp. */
export function formatTimestamp(ts: AuditHistoryEntry['timestamp']): string {
  if (typeof ts === 'string') return ts;
  if (ts && typeof ts._seconds === 'number') return new Date(ts._seconds * 1000).toISOString();
  return '—';
}
